import React from 'react';

import { FinancialAttachmentCard, PayerAddressCard } from '../../../../../../components/cards/financial';
import { AdditionalAttachmentCard } from '../../../../../../components/cards/financial/AttachmentCard';
import PrivacyPolicyCard from '../../../../../../components/cards/financial/PrivacyPolicyCard';
import FinancialPage from '../../../../../../features/FinancialPage';
import { CARD_CATEGORIES } from '../../../../../../shared/cardConfig/constants';
import { ATTACHMENT_FIELDS, PAYER_ADDRESS_FIELDS } from '../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../utils/constants';

// ----------------- Type Definitions -----------------
interface Field {
  key: string;
  required?: boolean;
}

interface Card {
  key: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: React.ComponentType<any>;
  fields?: Field[];
  hideSameAs?: boolean;
}

interface Page {
  route: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: React.ComponentType<any>;
  cards: Card[];
}

// ----------------- Page Template -----------------
const payerPageTemplate: Page = {
  route: PAGE_ROUTES.financial,
  Component: FinancialPage,
  cards: [
    {
      key: CARD_CATEGORIES.payer,
      Component: PayerAddressCard,
      hideSameAs: true,
      fields: [
        { key: PAYER_ADDRESS_FIELDS.address },
        { key: PAYER_ADDRESS_FIELDS.email },
        { key: PAYER_ADDRESS_FIELDS.taxNumber1, required: true },
        { key: PAYER_ADDRESS_FIELDS.taxNumber2 },
        { key: PAYER_ADDRESS_FIELDS.taxNumber3 },
        { key: PAYER_ADDRESS_FIELDS.taxNumber4 },
        { key: PAYER_ADDRESS_FIELDS.telephone1 },
        { key: PAYER_ADDRESS_FIELDS.telephone2 }
      ]
    },
    {
      key: CARD_CATEGORIES.financialAttachmentCard,
      Component: FinancialAttachmentCard,
      fields: [{ key: ATTACHMENT_FIELDS.financialCardAttachment }]
    },
    {
      key: CARD_CATEGORIES.additionalAttachmentCard,
      Component: AdditionalAttachmentCard,
      fields: [{ key: ATTACHMENT_FIELDS.additionalAttachment }]
    },
    {
      key: CARD_CATEGORIES.privacyPolicy,
      Component: PrivacyPolicyCard
    }
  ]
};

// ----------------- Export Pages -----------------
const pages: Page[] = [payerPageTemplate];

export default pages;